export default __webpack_public_path__ + "b7c99b8ff4039f1f0d8f773630faa53e.svg";